import ApplicationController from "./application_controller";

const STORAGE_KEY = "staging-notice-dismissed";

export default class extends ApplicationController {
    connect() {
        if (localStorage.getItem(STORAGE_KEY) === "true") {
            this.element.remove();
        }
    }

    dismiss() {
        localStorage.setItem(STORAGE_KEY, "true");
        this.element.remove();
    }
}
